import React from 'react';

import QuestionList from '@/components/molecules/question-list';
import { OnClickQuestionProps } from '@/components/molecules/question-list/question-item';
import useRealtimeWebViewQnaViewModel from '../view-models/useRealtimeWebViewQnaViewModel';

interface RealtimeQuestionsProps {
  onClickQuestion: ({ questionId, sectionName }: OnClickQuestionProps) => void;
  pageName: string;
}
const RealtimeWebviewQna = (props: RealtimeQuestionsProps) => {
  const viewModel = useRealtimeWebViewQnaViewModel();
  return (
    <QuestionList
      questionCard={{
        data: viewModel.questions,
        isLoading: viewModel.isQnaListLoading,
        hasNextPage: viewModel.hasNextPage,
        fetchNextPage: viewModel.fetchNextPage,
      }}
      onClickQuestion={props.onClickQuestion}
      pageName={props.pageName}
    />
  );
};

export default RealtimeWebviewQna;
